import { Col, Grid, Layout, Row } from "antd";
import React from "react";

import { ReactComponent as SFULogoFooter } from "../../assets/svgs/sfu-logo-footer.svg";

const { Footer } = Layout;

const MyFooter = () => {
  const screens = Grid.useBreakpoint();
  const rowMargin = screens.md
    ? "32px 6vw"
    : screens.sm
    ? "32px"
    : "16px";

  return (
    <Footer
      className="sfu-grey-background sfu-white-text"
      style={{ padding: 0 }}
    >
      <Row gutter={[0, 16]} style={{ margin: rowMargin }}>
        <Col md={12}>
          <p className="sub-heading-font">OFFICE OF THE VICE-PRESIDENT, RESEARCH AND INTERNATIONAL</p>
          <p>
            8888 University Drive
            <br />
            Burnaby, B.C.
            <br />
            Canada V5A 1S6
          </p>
        </Col>
        <Col md={12}>
          <p>
            <a href="https://www.sfu.ca/">
              <SFULogoFooter />
            </a>
          </p>

          <p>
            Simon Fraser University respectfully acknowledges the xʷməθkʷəy̓əm
            (Musqueam), Sḵwx̱wú7mesh Úxwumixw (Squamish), səl̓ilw̓ətaʔɬ
            (Tsleil-Waututh), q̓íc̓əy̓ (Katzie), kʷikʷəƛ̓əm (Kwikwetlem), Qayqayt,
            Kwantlen, Semiahmoo and Tsawwassen peoples on whose unceded
            traditional territories our three campuses reside.
          </p>
        </Col>
      </Row>
    </Footer>
  );
};

export default MyFooter;
